<template>
    <div
        class="currency-cell"
        :class="[field.alignment, { outlined: outlined, readonly: readonly }]"
        @dblclick="enableEdit"
    >
        <template v-if="editing">
            <a-input-number
                v-model="value"
                @blur="disableEdit"
                @keyup.enter="disableEdit"
                :formatter="formatterWithoutSymbol"
                :parser="parser"
                class="borderless-input"
            />
        </template>
        <template v-else>
            {{ formattedValue }}
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import PermissionController from "../../../../../components/permission-controller/PermissionController";

export default Vue.extend({
    name: "CurrencyCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            editing: false,
            value: this.record.data[this.field._id] || 0,
        };
    },
    computed: {
        formattedValue() {
            return this.formatter(this.value);
        },
        decimalFormat() {
            return this.field.options?.currency?.decimalFormat || "0";
        },
        currencySymbol() {
            return this.field.options?.currency?.symbol || "$";
        },
    },
    methods: {
        enableEdit() {
            if (!PermissionController.check(["table.update"])) {
                PermissionController.sendError();
                return;
            }
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.editing = true;
            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        },
        async disableEdit() {
            this.editing = false;
            try {
                const isChanged = this.record.data[this.field._id] !== this.value;
                if (isChanged) {
                    await this.$emit("update-record", {
                        recordId: this.record._id,
                        fieldId: this.field._id,
                        value: this.value,
                    });
                }
            } catch (error) {
                console.error(this.$t("tables.recordUpdatingError"), error);
                this.$message.error(this.$t("tables.recordUpdatingError"));
            }
        },
        formatter(value) {
            if (isNaN(value)) return "";
            const number = Number(value);
            if (isNaN(number)) return value;
            const parts = this.decimalFormat.split(".");
            const integerPart = parts[0].length;
            const decimalPart = parts[1]?.length || 0;
            const formattedNumber = number.toFixed(decimalPart).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return `${this.currencySymbol}${formattedNumber}`;
        },
        formatterWithoutSymbol(value) {
            if (isNaN(value)) return "";
            const number = Number(value);
            if (isNaN(number)) return value;
            const parts = this.decimalFormat.split(".");
            const integerPart = parts[0].length;
            const decimalPart = parts[1]?.length || 0;
            return number.toFixed(decimalPart).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        parser(value) {
            return value.replace(/\$\s?|(,*)/g, "");
        },
    },
});
</script>

<style scoped lang="scss">
.currency-cell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 4px 8px;
    transition: all 0.3s;

    &.outlined {
        border: 1px solid #d9d9d9;
        border-radius: 4px;

        &:not(.readonly) {
            cursor: pointer;

            &:hover {
                border-color: #40a9ff;
            }

            &:active {
                border-color: #096dd9;
            }
        }

        &.readonly {
            background-color: #f5f5f5;
            border-color: #d9d9d9;
            cursor: not-allowed;
        }
    }

    &.left {
        justify-content: flex-start;
    }

    &.center {
        justify-content: center;
    }

    &.right {
        justify-content: flex-end;
    }

    .borderless-input {
        border: none;
        outline: none;
        background: transparent;
        width: 100%;
        text-align: inherit;
    }
}
</style>
